/**
 * API Configuration for v2 Architecture
 *
 * Single API Gateway with path-based routing.
 */

type Environment = 'ravi-dev' | 'ql-dev' | 'ql-prod' | 'zebu-prod' | 'zebu-dev' | 'zebu-uat';

interface ApiEndpoints {
  api: string;
}

const getEnvironment = (): Environment => {
  return (process.env.REACT_APP_ENVIRONMENT as Environment) || '';
};

/**
 * Get API endpoints for the current environment
 */
export const getApiEndpoints = (): ApiEndpoints => {
  const env = getEnvironment();

  const endpoints: Record<Environment, ApiEndpoints> = {
    'ravi-dev': {
      api: process.env.REACT_APP_API_URL || '',
    },
    'ql-dev': {
      api: process.env.REACT_APP_API_URL || '',
    },
    'ql-prod': {
      api: process.env.REACT_APP_API_URL || '',
    },
    'zebu-prod': {
      api: process.env.REACT_APP_API_URL || '',
    },
    'zebu-dev': {
      api: process.env.REACT_APP_API_URL || '',
    },
    'zebu-uat': {
      api: process.env.REACT_APP_API_URL || '',
    },
  };

  return endpoints[env];
};

/**
 * Cognito configuration
 */
export const getCognitoConfig = () => ({
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
  region: process.env.REACT_APP_AWS_REGION || 'ap-south-1',
});

const apiConfig = {
  getApiEndpoints,
  getCognitoConfig,
};

export default apiConfig;
